/* eslint-disable react-hooks/exhaustive-deps */
import {
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Modal,
  Typography,
  IconButton,
} from "@mui/material";
import Button from "components/Button/button";
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
import { loadingAction } from "ReduxReducers/loadingReducer";
import { userlogin } from "ReduxReducers/loginReducers";
import Auto from "components/AutoComplete/AutoComplete";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import { wizardSignup } from "utils/authApi";
import { generateDataList, getSesstionDataByUserID, handleStreetAddress, showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import './SignUp.scss';
import { validateABN } from "utils/generic";
import getCroppedImg from "layouts/profile/editMyProfile/cropImage";
import Cropper from "react-easy-crop";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import ShowProfile from "components/ShowProfileModal/ShowProfileModal";
import { useMaterialUIController } from "context";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import { set } from "date-fns";
const errMsg = {
  color: `red`,
  fontSize: `11px`
};
const cropContainer = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: "80px",
};

const style = {
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  bgcolor: 'background.paper',
  boxShadow: 24,
  // p: 4,
  right: 'auto',
  bottom: 'auto',
  marginRight: '-50%',
};
let mandateFlag = false;
let myfile;

// Wizard Signup Screen
function Cover({ ...props }) {
  const { id } = useParams()
  const [businessNameErr, setBusinessNameErr] = useState(false)
  const [organizationTypeErr, setOrganizationTypeErr] = useState(false)
  const [industryTypeErr, setIndustryTypeErr] = useState(false)
  const [checked, setChecked] = useState(false);
  const [streetAddressErr, setStreetAddressErr] = useState(false);
  const [abnNumberErr, setAbnNumberErr] = useState(false);
  const [abnNumberErrMsg, setAbnNumberErrMsg] = useState('');
  const [companyCityErr, setCompanyCityErr] = useState(false);
  const [companyZipCodeErr, setCompanyZipCodeErr] = useState(false);
  const [stateErr, setStateErr] = useState(false);
  const [countryErr, setCountryErr] = useState(false);
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const stateListRef = useRef([]);
  const countryListRef = useRef([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let countryData = useSelector((state) => state.countryState.countryStateMenu.country)
  let stateData = useSelector((state) => state.countryState.countryStateMenu.state)

  const [values1, setValues1] = React.useState({
    companyStreetAddress: "",
    companyName: "",
    companyCity: "",
    companyZipCode: "",
    companyStateId: "",
    companyCountryId: "",
    id: id,
    industryType: "",
    organizationType: "",
    abnNumber: "",
  });
  //-------UPLOAD LOGO -----------------
  const [dynamicAspect, setDynamicAspect] = useState(1 / 1);
  const [file, setFile] = useState(null);
  const [actualFile, setActualFile] = useState(null);
  const [logoFileName, setLogoFileName] = useState("");
  const [showEYEBtn, setShowEYEBtn] = useState(false);
  const [showImageFlag, setShowImageFlag] = useState(false);
  const [openCropImageModal, setOpenCropImageModal] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const saveCropedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(file, croppedAreaPixels);
      setFile(croppedImage);
      myfile = await fetch(croppedImage)
        .then((r) => r.blob())
        .then((blobFile) => new File([blobFile], actualFile.name, { type: "image/*" }));
      setActualFile(myfile);
      setLogoFileName(actualFile.name);
      setOpenCropImageModal(false);
      setZoom(1);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels]);

  const handleCropCancel = async () => {
    setOpenCropImageModal(false)
    setFile(null);
    setActualFile(null);
    setLogoFileName('');
    setShowEYEBtn(false)
    setDynamicAspect(1 / 1);
  };
  const saveFile = (e) => {
    try {

      const fileInput = e.target;
      const file = fileInput.files[0];
      if (file) {
        setFile(null);
        let fileSizeInMB = file.size / (1024 * 1024);
        if (fileSizeInMB > 1) {
          showResMsg(`File can't be more than 1 MB`, 2000, false);
        } else {
          setOpenCropImageModal(true);
          setFile(URL.createObjectURL(file));
          setActualFile(file);
          setLogoFileName(file.name);
          const reader = new FileReader();
          reader.onloadend = () => {
            setShowImageFlag(false);
            setShowEYEBtn(true);
          };
          reader.readAsDataURL(file);
        }
      } else {
        // Handle the case when no file is selected
        setFile(null);
        setActualFile(null);
        setLogoFileName('');
        setShowEYEBtn(false);
      }
      // Reset the file input value to allow re-selection of the same file
      fileInput.value = null;
    } catch (error) {
      console.log("Catch in saveFile=", error);
    }
  };

  const saveSignupData = () => {
    sessionStorage.setItem("SIGN_UP_TEMP_DATA", JSON.stringify(values1));
  };
  const handleChange1 = (name) => (event) => {
    if (event.target.validity !== undefined && event.target.validity.valid === true) {
      if (name === "abnNumber") {
        let value = event.target.value.replace(/\D/g, ''); // Remove all non-digit characters

        if (name === "abnNumber") {
          value = value.slice(0, 11);

          if (value.length > 2) {
            value = value.slice(0, 2) + ' ' + value.slice(2);
          }
          if (value.length > 6) {
            value = value.slice(0, 6) + ' ' + value.slice(6);
          }
          if (value.length > 10) {
            value = value.slice(0, 10) + ' ' + value.slice(10);
          }
          setValues1({ ...values1, [name]: value });
        }

      } else
        setValues1({ ...values1, [name]: event.target.value });


    }
    else if (event.target.validity === undefined) {
      setValues1({ ...values1, [name]: event.target.value });
    }
    if (name === "companyName") setBusinessNameErr(false);
    if (name === "organizationType") setOrganizationTypeErr(false);
    if (name === "industryType") setIndustryTypeErr(false);

  };
  const clearErrState = () => {
    setBusinessNameErr(false);
    // setAbnNumberErr(false);
    setOrganizationTypeErr(false);
    setIndustryTypeErr(false);
    setStreetAddressErr(false);
    setCompanyCityErr(false);
    setCompanyZipCodeErr(false);
    setStateErr(false);
    setCountryErr(false);
  }

  const signup = async () => {
    try {

      clearErrState();
      mandateFlag = false;
      // const abnNumber = values1.abnNumber.toString().trim();
      // if (abnNumber) {
      //   if (!validateABN(abnNumber)) {
      //     showResMsg(genericMessage.invalidABN, 2000, false);
      //     mandateFlag = true;
      //   }
      // }
      // if (abnNumber.length === 0) {
      //   mandateFlag = true;
      //   setAbnNumberErr(true);
      //   setAbnNumberErrMsg("ABN Number can't be blank");
      // }
      // if (abnNumber && abnNumber.length < 9) {
      //   mandateFlag = true;
      //   setAbnNumberErr(true);
      //   setAbnNumberErrMsg("ABN Number must be at least 9 digits");
      // }

      mandateFlag = validateField(values1.companyName, setBusinessNameErr) || mandateFlag;
      mandateFlag = validateField(values1.organizationType, setOrganizationTypeErr) || mandateFlag;
      mandateFlag = validateField(values1.industryType, setIndustryTypeErr) || mandateFlag;
      mandateFlag = validateField(values1.companyStreetAddress, setStreetAddressErr) || mandateFlag;
      mandateFlag = validateField(values1.companyCity, setCompanyCityErr) || mandateFlag;
      mandateFlag = validateField(values1.companyZipCode, setCompanyZipCodeErr) || mandateFlag;
      mandateFlag = validateField(values1.companyStateId, setStateErr) || mandateFlag;
      mandateFlag = validateField(values1.companyCountryId, setCountryErr) || mandateFlag;

      if (mandateFlag) {
        return;
      }
      else if (checked !== true) {
        showResMsg(genericMessage.acceptConditions, 2000, false);
        mandateFlag = true;
        return;
      } else {
        // values1.fileName = logoFileName;

        const formData = new FormData();
        for (const key in values1) {
          if (values1.hasOwnProperty(key)) {
            formData.append(key, values1[key]);
          }
        }
        if (actualFile) {
          formData.append('file', actualFile);
          formData.append('fileName', logoFileName);
        }
        console.log("formData=", formData);

        wizardSignup(formData, async (data) => {
          if (data.Result_Status) {
            showResMsg(genericMessage.saved, 2000, true)
            let flag = await getSesstionDataByUserID(data.Result_Output.data._id, dispatch);
            if (!flag) {
              sessionStorage.clear();
              navigate("/");
            }
            dispatch(userlogin(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))))

            sessionStorage.setItem("TOKEN", data.Result_Output.token)
            // swal({
            //   title: "Welcome to Invoice & Recover! ", text: "", icon: "success", color: 'green',
            //   buttons: false, closeOnClickOutside: false, closeOnEsc: false,   className: 'custom-swal'
            // });

            swal({
              title: "Welcome to Invoice & Recover! ", text: "You are now a member", icon: "success", color: 'green',

              buttons: false, closeOnClickOutside: false, closeOnEsc: false, className: 'custom-swal'


            });

            setTimeout(() => {
              window.location.href = "/dashboard";
            }, 2000);
          } else {
            dispatch(loadingAction(false))
            showResMsg(data.Result_Message, 2000, false)
          };
        }, dispatch)
      }
    } catch (error) {
      console.log("Catch in  signup user=", error);
    }
  };

  useEffect(() => {
    (async () => {
      stateListRef.current = stateData;
      countryListRef.current = countryData;
      setCountry(await generateDataList(countryData, "_id", "countryName"));
      setState(await generateDataList(stateData, "_id", "stateName"));
    })()
    if (sessionStorage.getItem("SIGN_UP_TEMP_DATA") !== "" && sessionStorage.getItem("SIGN_UP_TEMP_DATA") !== null) {
      setValues1(JSON.parse(sessionStorage.getItem("SIGN_UP_TEMP_DATA")))
      sessionStorage.clear("SIGN_UP_TEMP_DATA")
    }
    dispatch(loadingAction(false));
  }, [])





  const handleStreetOnChange = (e) => {
    if (e.target.value === "") {
      setValues1((prevValues) => ({
        ...prevValues,
        companyStreetAddress: "",
        companyCity: "",
        companyZipCode: "",
        companyStateId: "",
        companyCountryId: "",
      }));
    } else {
      setValues1((prevValues) => ({
        ...prevValues,
        companyStreetAddress: e.target.value,
      }));
      setStreetAddressErr(false);
      setCompanyCityErr(false);
      setCompanyZipCodeErr(false);
      setStateErr(false);
      setCountryErr(false);
    }

  }



  const industryOptions = [
    "Accommodation and food service",
    "Administrative and support services",
    "Agriculture, Forestry and Fishing",
    "Arts and recreation services",
    "Construction",
    "Education and Training",
    "Financial and Insurance",
    "Health care and social assistance",
    "Information media and telecommunications",
    "Manufacturing",
    "Mining",
    "Professional, scientific and technical services",
    "Rental, hiring and real estate services",
    "Retail and wholesale trade",
    "Tourism",
    "Transport, postal and warehousing"
  ];



  // const { tableBorder } = getColorMappings(sidenavColor);

  // var element = document.getElementsByTagName('fieldset');
  // for (let i = 0; i < element.length; i++) {
  //  element[i].style.borderColor = `${darkMode ? "white" : "lightgray"} : ${darkMode ? "white" : table}`;
  // }







  // var element = document.getElementsByTagName('label');
  // for (let i = 0; i < element.length; i++) {
  //  element[i].style.color = darkMode ? "white" : "black";
  // }

  // let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
  // for (let i = 0; i < labelShrink.length; i++) {
  //   labelShrink[i].style.color = darkMode ? "white" : "black";;
  // }

  return (
    <>
      <div className="container">
        <div className="bgimage">
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "150vh" }}>
            <CoverLayout>
              <Card style={{
                padding: "12px", maxWidth: '660px', width: '100%', margin: "0 auto", maxHeight: 'auto',
                // position: 'fixed',
                // top: '50%',
                // left: '50%',
                // transform: 'translate(-50%, -50%)'
              }} >
                <MDBox
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="success"
                  mx={2}
                  mt={-3}
                  p={3}
                  mb={1}
                  textAlign="center"


                >
                  <MDTypography variant="h4" fontWeight="medium" color="white" mt={1} style={{ fontSize: "16px" }}>
                    Invoice & Recover (Business User Details)
                  </MDTypography>
                  <MDTypography variant="h4" fontWeight="medium" color="white" mt={1} style={{ fontSize: "15px" }}>
                    Get Started With Your Silver Plan
                  </MDTypography>

                </MDBox>

                <Grid container spacing={4} p={3} mt={-7}>
                  <Grid item xs={12} lg={6}>
                    <MDBox>

                      <MDInput
                        type="text"
                        label="Business Name"
                        variant="standard"
                        fullWidth
                        inputProps={{
                          maxLength: 30
                        }}
                        value={values1.companyName}
                        onChange={handleChange1("companyName")}
                      />
                      {businessNameErr ? <span style={errMsg}>Business Name can't be blank</span> : ""}
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={6} >
                    <MDBox>
                      <MDInput
                        type="text"
                        label="ABN Number (Optional)"
                        variant="standard"
                        fullWidth

                        inputProps={{
                          pattern: "^[0-9 ]+$",
                        }}
                        value={values1.abnNumber}
                        onChange={handleChange1("abnNumber")}
                      />
                      {abnNumberErr ? <span style={errMsg}>{abnNumberErrMsg}</span> : ""}
                    </MDBox>

                    <MDTypography
                      variant="button"
                      color="warning"
                      fontWeight="medium"
                      textGradient

                    >
                      <a style={{ fontSize: "12px", borderBottom: "2px solid #FFC107" }} href="https://abr.business.gov.au/" target="_blank" rel="noreferrer">
                        Check ABN Number
                      </a>
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <FormControl fullWidth variant="standard" style={{ minHeight: "45.1px" }}>
                      <InputLabel id="demo-simple-select-label" variant="standard">Organization Type</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        // id="demo-simple-select"
                        id="demodata"
                        label="Organization Type"
                        style={{ minHeight: "30px" }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 200,
                            },
                          },
                        }}
                        autoFocus={true}
                        onChange={handleChange1("organizationType")}
                        value={values1.organizationType}
                      >
                        {/* <MenuItem value="">Select..</MenuItem> */}
                        <MenuItem value="Business">Business</MenuItem>
                        <MenuItem value="Individual">Individual</MenuItem>


                      </Select>

                    </FormControl>
                    {organizationTypeErr ? <span style={errMsg}>Please Select Organization Type</span> : ""}
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <FormControl fullWidth variant="standard" style={{ minHeight: "45.1px" }}>
                      <InputLabel id="demo-simple-select-label" variant="standard">Industry Type</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        // id="demo-simple-select"
                        id="demodata"
                        label="Industry Type"
                        style={{ minHeight: "30px" }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 200,
                            },
                          },
                        }}
                        autoFocus={true}
                        onChange={handleChange1("industryType")}
                        value={values1.industryType}
                      >
                        {industryOptions.map((option, index) => (
                          <MenuItem key={index} value={option}>{option}</MenuItem>
                        ))}


                      </Select>

                    </FormControl>
                    {industryTypeErr ? <span style={errMsg}>Please Select Industry Type</span> : ""}
                  </Grid>


                  <Grid item xs={12} lg={6}>

                    <label htmlFor="fileInput">
                      <TextField
                        type="text"
                        label="Upload Logo"
                        variant="standard"
                        fullWidth
                        className="form-control"
                        style={{ maxWidth: "287px", width: "100%", }}
                        value={logoFileName}
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <label className="ress" htmlFor="fileInput">
                                <Button
                                  // sx={{ background: "red", paddingTop: "1px !important", paddingBottom: "0px" }}
                                  // color={"dark"}
                                  // variant="contained"
                                  style={{ color: 'white', fontSize: "14px", marginTop: "4px", color: "#000000", marginLeft: "-19px", textDecoration: "2px solid underline", fontWeight: "500" }}
                                  component="span"
                                  size="small"
                                  allign="right"
                                >
                                  Choose Logo
                                </Button>
                              </label>
                              <IconButton style={{ margRight: "2px" }}>
                                {showEYEBtn ?
                                  <Visibility fontSize="medium" color="info" onClick={() => { setShowImageFlag(true); }} />
                                  :
                                  <VisibilityOff fontSize="medium" color="grey" />
                                }
                              </IconButton>

                            </InputAdornment>
                          ),
                        }}
                      />
                      <input
                        type="file"
                        accept="image/*"
                        id="fileInput"
                        style={{ display: "none" }}
                        onChange={saveFile}
                      />
                    </label>
                    {/* <IconButton style={{ marginLeft: "2px" }}>
                      {showEYEBtn ?
                        <Visibility fontSize="medium" color="info" onClick={() => { setShowImageFlag(true); }} />
                        :
                        <VisibilityOff fontSize="medium" color="grey" />
                      }
                    </IconButton> */}
                  </Grid>
                  <Grid item xs={12} lg={6} className='google'>
                    <Auto
                      onChange={handleStreetOnChange}
                      onPlaceSelected={(place, e) => handleStreetAddress(place, e, (data) => {
                        setValues1((prevValues) => ({
                          ...prevValues,
                          companyZipCode: data.zipCode,
                          companyCity: data.city,
                          companyCountryId: data.countryId,
                          companyStateId: data.stateId,
                          companyStreetAddress: data.streetAddress,
                          companyStateName: data.stateName,
                          companyCountryName: data.countryName

                        }));
                      }, stateListRef, countryListRef)}
                      inputProps={{
                        maxLength: 100
                      }}
                      value={values1.companyStreetAddress}
                      variant="standard" />
                    <div style={{ marginTop: "10px" }}>
                      {streetAddressErr ? <span style={errMsg}>Street Address can't be blank</span> : ""}
                    </div>



                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <MDBox>
                      <MDInput
                        type="text"
                        label="City"
                        variant="standard"
                        fullWidth

                        inputProps={{
                          // pattern: "^[a-zA-Z0-9@.]+$",
                          maxLength: 30
                        }}
                        value={values1.companyCity}
                        onChange={(e) => {
                          const value = e.target.value;
                          setValues1({ ...values1, companyCity: value });

                          if (value.trim() !== "") {
                            setCompanyCityErr(false); // ✅ remove error automatically
                          }
                        }}

                      />
                      {companyCityErr ? <span style={errMsg}>City can't be blank</span> : ""}

                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <MDBox>
                      <MDInput
                        type="text"
                        label="Zip Code"
                        variant="standard"
                        fullWidth

                        inputProps={{
                          // inputMode: 'numeric',
                          pattern: '[0-9]*',
                          maxLength: 4
                        }}
                        value={values1.companyZipCode}
                        onChange={(e) => {
                          const value = e.target.value;
                          setValues1({ ...values1, companyZipCode: value });

                          if (value.trim() !== "") {
                            setCompanyZipCodeErr(false); // ✅ remove error automatically
                          }
                        }}
                      />
                      {companyZipCodeErr ? <span style={errMsg}>Zip Code can't be blank</span> : ""}
                    </MDBox>
                  </Grid>
                  {/* 
          <Grid item xs={12} lg={3} >
            <FormControl fullWidth variant="standard" sx={{ m: 1, mt: 0, ml: 0 }} style={{ minHeight: "45.1px" }}>
              <InputLabel id="demo-simple-select-standard-label">Country</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                style={{ minHeight: "29.11px" }}
                 className="setCountry"
                label="Country"

                disabled
                value={values1.companyCountryId}
                onChange={(e) => setValues1({ ...values1, companyCountryId: e.target.value })}
              >
                {country}
              </Select>
            </FormControl>
          </Grid> */}

                  <Grid item xs={12} lg={6}>
                    <FormControl fullWidth variant="standard" style={{ minHeight: "45.1px" }}>
                      <InputLabel id="demo-simple-select-label" variant="standard">Country</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        // id="demo-simple-select"
                        id="demodata"
                        label="Country"
                        style={{ minHeight: "29.11px" }}
                        value={values1.companyCountryId}
                        // onChange={(e) => setValues1({ ...values1, companyCountryId: e.target.value })}
                        onChange={(e) => {
                          const value = e.target.value;
                          setValues1({ ...values1, companyCountryId: value });

                          if (value.trim() !== "") {
                            setCountryErr(false); // ✅ remove error automatically
                          }
                        }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 200,
                            },
                          },
                        }}

                      >
                        {country}
                      </Select>
                      {countryErr ? <span style={errMsg}>Please Select Country</span> : ""}
                    </FormControl>

                  </Grid>
                  <Grid item xs={12} lg={6} >
                    <FormControl fullWidth variant="standard" sx={{ m: 1, mt: 0, ml: 0 }} style={{ minHeight: "45.1px" }}>
                      <InputLabel id="demo-simple-select-standard-label">State</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="State"
                        className="setCountry"
                        style={{ minHeight: "29.11px" }}
                        value={values1.companyStateId}
                        onChange={(e) => {
                          const value = e.target.value;
                          setValues1({ ...values1, companyStateId: value });

                          if (value.trim() !== "") {
                            setStateErr(false); // ✅ remove error automatically
                          }
                        }}
                      >
                        {state}
                      </Select>
                      {stateErr ? <span style={errMsg}>Please Select State</span> : ""}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} lg={12} textAlign={"center"} style={{ marginTop: '-9px' }}>

                    <Checkbox className="checked" onChange={() => setChecked(checked === false ? true : false)}
                      sx={{
                        borderColor: "pink",
                        '&.Mui-checked': {
                          borderColor: "pink",
                        },
                      }} />
                    <MDTypography
                      variant="button"
                      fontWeight="regular"
                      color="text"
                      sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                    >
                      &nbsp;&nbsp;By registering I accept the&nbsp;
                    </MDTypography>
                    <MDTypography
                      component="a"
                      href="https://edios.global/our-solutions/"
                      variant="button"
                      fontWeight="bold"
                      color="info"
                      onClick={saveSignupData}
                      textGradient
                    >
                      Terms and Conditions&nbsp;&nbsp;
                    </MDTypography>
                    <MDTypography
                      variant="button"
                      fontWeight="regular"
                      color="text"
                      sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                    >
                      &nbsp;&nbsp;and &nbsp;
                    </MDTypography>
                    <MDTypography
                      component="a"
                      href="https://edios.global/our-solutions/"
                      variant="button"
                      fontWeight="bold"
                      color="info"
                      onClick={saveSignupData}
                      textGradient
                    >
                      Privacy Policy.
                    </MDTypography>

                  </Grid>
                </Grid>
                <Grid container style={{ display: "flex", justifyContent: "center", }}>
                  <Grid item xs={4}>
                    <MDBox >
                      <MDButton variant="gradient" color="info" fullWidth onClick={signup}>
                        Get Started
                      </MDButton>
                    </MDBox>
                  </Grid>
                </Grid>
                <ShowProfile
                  open={showImageFlag}
                  fileName={file}
                  closeModalClick={() => { setShowImageFlag(false) }}
                />
                <Modal
                  open={openCropImageModal}
                  onClose={() => { handleCropCancel() }}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                  style={style}
                >
                  <Grid className="crop-image-wrapper" id="modal-modal-title" >
                    <Grid container spacing={2} style={{ maxHeight: '400px', overflowY: 'auto' }}>
                      <Grid style={cropContainer}>
                        <Cropper
                          image={file}
                          crop={crop}
                          zoom={zoom}
                          aspect={dynamicAspect}
                          onCropChange={setCrop}
                          onCropComplete={onCropComplete}
                          onZoomChange={setZoom}
                        />
                      </Grid>
                      <Grid container spacing={2} className="crop-control" >
                        <Grid item  >
                          <Typography type="label" style={{ color: "white", fontSize: "12px" }}>
                            Aspect Ratio
                          </Typography>{" "}
                          <div style={{ display: "flex", justifyContent: 'center', }}>
                            <select onChange={e => { return setDynamicAspect(parseFloat(e.target.value)); }}  >
                              <option>1/1</option>
                              <option value={'1.23'}>1.23/1</option>
                              <option value={'1.33'}>1.33/1</option>
                              <option value={'1.43'}>1.43/1</option>
                              <option value={'1.625'}>1.66/1</option>
                              <option value={'4.136/2'}>4/2</option>
                              <option value={'1.7'}>16/9</option>
                            </select>
                          </div>
                        </Grid>
                        <Grid item >
                          <Typography type="label" style={{ color: "white", textAlign: "center", fontSize: "12px" }}>
                            Zoom
                          </Typography>&nbsp;
                          <input
                            type="range"
                            value={zoom}
                            min={1}
                            max={11}
                            step={0.1}
                            aria-labelledby="Zoom"
                            onChange={(e) => {
                              setZoom(e.target.value)
                            }}
                          />
                        </Grid>
                        <Grid item>
                          <Button className="modalButton cropimgbtn" onClick={saveCropedImage}>
                            Crop
                          </Button>
                        </Grid>
                        <Grid item style={{ cursor: "pointer", marginRight: "14px", }}>
                          <Button className="modalButton crop-closebtn" onClick={handleCropCancel}>
                            Close
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Modal>
              </Card>

            </CoverLayout>
          </div>
        </div>
      </div>
    </>
  );
}

export default Cover;


